/**
 * This helps enable certain Apollo Server/Studio features
 * https://www.apollographql.com/docs/studio/metrics/client-awareness/#using-apollo-server-and-apollo-client
 */

const CLIENT_NAME = 'order';
const CLIENT_VERSION = '0.0.1';

export const getClientIDHeaders = (): Headers => {
  return {
    'apollographql-client-name': CLIENT_NAME,
    'apollographql-client-version': CLIENT_VERSION,
  };
};

// ────────────────────────────────────────────────────────────────────────────────

type Headers = {
  readonly 'apollographql-client-name': string;
  readonly 'apollographql-client-version': string;
};
